import React, {Component} from 'react';
import {gpn} from "../GPN"
import Back from "../sections/Back";
import Select from "../sections/MUI/Select";
import req from "../req";
import Field from "../sections/MUI/Field";
import config from "../config";
import Icon from "../sections/MUI/Icon";
import axios from "axios";
import FileDownload from "js-file-download";
import {toast} from "react-toastify";

class Storages extends Component {

    state = {
        files: [],
        searched: [],

        filesUsedSpace: 0,

        usedSpace: null,

        search: "",

        prefix: "auth"
    };


    componentDidMount() {
        this.getUsedSpace();
        this.getFiles("auth");
    }


    getUsedSpace() {
        req.get(`/storage/space/used`)
            .then(r => {
                if (r) {
                    let {used} = r;
                    this.setState({
                        usedSpace: used
                    });
                }
            });
    }

    getFiles(prefix = "auth") {
        prefix = prefix ? prefix.toString().trim() : "";
        if (prefix === "") {
            prefix = "auth";
        }

        req.get(`/storage/files?prefix=${prefix}`)
            .then(files => {
                files = files ? files : [];
                let {search} = this.state;
                search = search ? search.toString().trim() : "";
                this.setState({
                    files
                });

                this.handleSearch(search, files);
            })
    }

    downloadFile(key = "") {
        toast.info("در حال دانلود فایل ...", {autoClose: 1500});
        let ext = key.toLowerCase().endsWith(".pdf") ? "pdf" : "rar";

        let fn = key.replace(".rar.rar", "").replace(".pdf.pdf", "").replace(".rar", "").replace(".pdf", "").replace(".zip.zip", "")
            .replace(".zip", "").trim();

        axios.get(`${config.api}/admin/storage/file?prefix=${this.state.prefix}&file=${key}`, {
            headers: {
                "authorization": config.token
            },
            responseType: 'blob'
        })
            .then(r => {
                FileDownload(r.data, `${fn}.${ext}`);
            })
            .catch(err => {
                console.error(err);
                config.handleError(err);
            });

    }

    handleSearch(s = "", mFiles = []) {
        s = s ? s.toString().trim() : "";

        let {files = []} = this.state;
        if (mFiles) {
            if (mFiles.length > 0) {
                files = mFiles;
            }
        }
        let chs = s.replace(/\-/g, " ")
            .replace(/\+/g, " ")
            .replace(/\_/g, " ")
            .replace(/\//g, " ")
            .trim();
        if (chs.toString().trim() === "") {
            return this.setState({searched: files});
        }
        let final = files.filter(el => {
            let f = String(el || "")
                .replace(/\-/g, " ")
                .replace(/\+/g, " ")
                .replace(/\_/g, " ")
                .replace(/\//g, " ")
                .replace(/\s+/g, " ")
            return f.includes(chs) || f.includes(s);
        });
        return this.setState({searched: final});
    }

    formatFileSize(bytes) {
        if (bytes === 0) return '0 B';

        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        const size = bytes / Math.pow(1024, i);

        return `${size.toFixed(2)}${units[i]}`;
    }

    render() {
        let {prefix, searched, search, usedSpace, filesUsedSpace} = this.state;
        return (
            <div className="storages">
                <Back {...this.props}/>
                <br/>
                <div className="row justify-content-center">
                    <div className="col-md-5">
                        <Select simple
                                name="prefix"
                                value={prefix}
                                onChange={(name, value) => {
                                    this.setState({
                                        [name]: value,
                                        files: []
                                    });
                                    this.getFiles(value);
                                }}
                                label="انتخاب پوشه"
                                options={[
                                    {t: "احراز هویت (ویدیو)", v: "auth"},
                                    {t: "اعتبارسنجی", v: "validation"}
                                ]}/>
                    </div>
                </div>
                <br/>
                <div className="row justify-content-center">
                    <div className="col-md-7">
                        <Field name="search"
                               style={{direction: config.isFa(search) ? "rtl" : "ltr"}}
                               value={search}
                               onChange={(name, value) => {
                                   this.setState({[name]: value});
                                   this.handleSearch(value);
                               }}
                               maxLength={300}
                               label="جستجو ..."/>
                    </div>
                </div>
                <br/>
                {usedSpace ?
                    <h1>«مقدار <span className="used">{usedSpace}&nbsp;گیگابایت</span>&nbsp;از&nbsp;<span
                        className="total">100.00 گیگابایت</span> مصرف شده»</h1>
                    : null}
                <br/>
                {/*<h2><span>مقدار فضای پوشه:</span><span>{filesUsedSpace}&nbsp;GB</span></h2>*/}
                <h2><span>تعداد فایل ها:</span><span>{searched?.length}</span></h2>
                <br/>
                <div className="list">
                    <div className="row justify-content-center">
                        {
                            searched?.length > 0 ?
                                searched?.map((f, i) =>
                                    <div key={"file" + i} className="col-md-6">
                                        <article>
                                            <div className="file-name"
                                                 style={{textAlign: "center", fontWeight: "bold"}}>{f.replace(/(\.rar)|(\.pdf)|(\.zip)/g,"")}</div>
                                            <div className="buttons" style={{marginTop: 8}}>
                                                <div className="row justify-content-center">
                                                    <Icon i="download" className="download" solid
                                                          onClick={() => this.downloadFile(f)}/>
                                                </div>
                                            </div>
                                        </article>

                                    </div>
                                )
                                : <div style={{textAlign: "center"}}>فایلی وجود ندارد!</div>
                        }
                    </div>

                </div>
            </div>
        );
    }
}

export default gpn(Storages);